import {
    Col, Row,
} from 'antd';
import { CSSProperties } from 'react';
import { Helmet } from 'react-helmet';
import { Navigate } from 'react-router-dom';

import {
    LoginForm, ThemeSwitcher,
} from '@/components';
import { AppRoute } from '@/constants';
import { useUserStore } from '@/stores';

const loginFormWrapperStyle: CSSProperties = {
    width: '100%',
    maxWidth: '400px',
};

export const LoginPage = () => {
    const { user } = useUserStore();

    if (user) {
        return <Navigate to={AppRoute.Root} replace />;
    }

    return (
        <>
            <Helmet>
                <title>Логін</title>
            </Helmet>
            <Row align="middle" justify="end" style={{ flexGrow: 1 }}>
                <Col span={4}>
                    <ThemeSwitcher />
                </Col>
            </Row>
            <Row justify="center" style={{ flexGrow: 2 }}>
                <div style={loginFormWrapperStyle}>
                    <LoginForm />
                </div>
            </Row>
        </>
    );
};
